import { render, staticRenderFns } from "./personnelAssess.vue?vue&type=template&id=8e4c3e6e&scoped=true&"
import script from "./personnelAssess.vue?vue&type=script&lang=js&"
export * from "./personnelAssess.vue?vue&type=script&lang=js&"
import style0 from "./personnelAssess.vue?vue&type=style&index=0&id=8e4c3e6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e4c3e6e",
  null
  
)

export default component.exports